import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@paysera/ui';
const SelectMultipleField = ({ name, label, options, onChange }) => {
    const { control, watch, setValue } = useFormContext();
    const selectedValues = watch(name) || '';
    const handleCheckboxChange = (value, checked) => {
        const valuesArray = selectedValues ? selectedValues.split('+') : [];
        if (checked) {
            valuesArray.push(value);
        }
        else {
            const index = valuesArray.indexOf(value);
            if (index > -1) {
                valuesArray.splice(index, 1);
            }
        }
        setValue(name, valuesArray.join('+'));
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name, value: valuesArray.join('+') } });
    };
    return (<>
            <label htmlFor={name} className="block mb-2 text-sm font-medium text-gray-900">
                {label}
            </label>
            {options === null || options === void 0 ? void 0 : options.map((option) => (<div key={option.value} className="pb-2">
                    <Controller name={name} control={control} render={() => (<Checkbox className="items-start" id={`${name}_${option.value}`} checked={selectedValues.split('+').includes(option.value)} onChange={({ target }) => handleCheckboxChange(option.value, target.checked)} label={option.label}/>)}/>
                </div>))}
        </>);
};
export default SelectMultipleField;
